import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';

@Component({
  selector: 'page-mapmodal',
  templateUrl: 'mapmodal.html',
})
export class MapmodalPage {

  desc: string = '';

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController
  ) {
    this.desc = navParams.get('desc');
  }

  close() {
    this.viewCtrl.dismiss();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MapmodalPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/mapmodal/mapmodal.ts